import React from 'react';
import PropTypes from 'prop-types';

const ToastError = ({ color = '#FF4142' }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
        <g fill="none" fillRule="evenodd">
            <path
                fill={color}
                fillRule="nonzero"
                d="M10,19.5 C4.75329488,19.5 0.5,15.2467051 0.5,10 C0.5,4.75329488 4.75329488,0.5 10,0.5 C15.2467051,0.5 19.5,4.75329488 19.5,10 C19.5,15.2467051 15.2467051,19.5 10,19.5 Z M10,18.5 C14.6944204,18.5 18.5,14.6944204 18.5,10 C18.5,5.30557963 14.6944204,1.5 10,1.5 C5.30557963,1.5 1.5,5.30557963 1.5,10 C1.5,14.6944204 5.30557963,18.5 10,18.5 Z"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7,7 L12.8197301,12.8197301"
            />
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M7,7 L12.8197301,12.8197301"
                transform="matrix(-1 0 0 1 19.82 0)"
            />
        </g>
    </svg>
);

ToastError.propTypes = {
    color: PropTypes.string,
};

export default ToastError;
